import {ProfileGrids} from './profile/profile_grids';
import {FrontendActivityLog} from './profile/frontend_activity_log';
import {Common} from './profile/common';
import {SidebarMenu} from './profile/sidebar_menu';

jQuery(function($) {
    const profileGrids = new ProfileGrids();
    profileGrids.init();

    const frontendActivityLog = new FrontendActivityLog();
    frontendActivityLog.init();

    const common = new Common();
    common.init();

    const sidebarMenu = new SidebarMenu();
    sidebarMenu.init();
});